import React from 'react';
import PropTypes from 'prop-types';
import {
  Rectangle,
  Cushion,
  Typography,
  Space,
  Shadow,
  Grid,
  FlexContainer,
} from '@pitchero/react-ui';
import Icon from '../../icon';
import { Trans } from '../../../lib/i18n';

const ProductPageAssignmentBadge = ({ assignment }) => {
  if (!assignment) {
    return null;
  }

  return (
    <Space bottom="medium">
      <Shadow>
        <Rectangle fill="white" radius="rounded" style={{ overflow: 'hidden' }}>
          <Grid columns="55px 1fr">
            <Rectangle fill="primary">
              <FlexContainer alignItems="center" style={{ height: '100%' }} justifyContent="center">
                <Icon name="info-circle" size={26} color="primaryContrast" />
              </FlexContainer>
            </Rectangle>
            <Cushion vertical="small" horizontal="medium">
              <Space bottom="xsmall">
                <Typography preset="tag--large" component="div">
                  {assignment.requester}
                </Typography>
              </Space>
              <Typography color="dustygrey" preset="tag--small" component="div">
                <Trans i18nKey="shop:asked_you_to_buy_this">Asked you to buy this</Trans>
              </Typography>
            </Cushion>
          </Grid>
        </Rectangle>
      </Shadow>
    </Space>
  );
};

ProductPageAssignmentBadge.propTypes = {
  assignment: PropTypes.shape(),
};

ProductPageAssignmentBadge.defaultProps = {
  assignment: null,
};

export default ProductPageAssignmentBadge;
